/**
 * @desc undefined
 */
import { DeptUser, DeptUserQuery } from '@eastcoal/api/auth/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryDeptUserTreeParameter = DeptUserQuery

const method = 'GET'
const url = '/auth/dept/users'

export const queryDeptUserTreeApi = (
  params?: QueryDeptUserTreeParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<Array<DeptUser>>({
    method,
    url,
    params,
    ...config
  })
}

queryDeptUserTreeApi.method = method
queryDeptUserTreeApi.url = url
